export default (theme: Object) => ({
  menu: {
    zIndex: theme.zIndex.modal,
  },
});
